/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';

const initialState_selectValue = 0;

/** State to store ID value of the selected row in the main table on the shipment page. */
const selectionSlice = createSlice({
    name: 'mainTableSelectValue',
    initialState: initialState_selectValue,
    reducers: {
        setSelectValueChange: (state, action) => {
            return action.payload;
        },
        resetSelectValue: () => {
            return initialState_selectValue;
        },
    },
});

export const { setSelectValueChange, resetSelectValue } = selectionSlice.actions;
export default selectionSlice.reducer;
